import type { ReactNode } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Textfield } from "@similarweb/ui-components";
import { Text, Flex } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

interface ISettingSectionProps {
    title: string;
    onValueChange: (value: string) => void;
    defaultValue?: string;
    fieldPlaceholder?: string;
    isDisabled?: boolean;
    autoFocus?: boolean;
    error?: string;
    onApply?: () => void;
    children?: ReactNode;
    maxLength?: number;
}

export const InputSettingSection = ({
    title,
    onValueChange,
    defaultValue = "",
    fieldPlaceholder = "",
    isDisabled,
    autoFocus,
    error,
    onApply,
    children,
    maxLength,
}: ISettingSectionProps) => (
    <Flex
        flexDirection="column"
        gap="8px"
    >
        <Flex
            flexDirection="column"
            gap="12px"
        >
            <Text
                fontVariant="subtitle2"
                color={colorsPalettes.carbon[400]}
            >
                {title}
            </Text>
            <Textfield
                defaultValue={defaultValue}
                onChange={onValueChange}
                placeholder={fieldPlaceholder}
                onApplyClick={!error ? onApply : undefined}
                ApplyButtonText={onApply ? translate("global.add") : undefined}
                error={!!error}
                disabled={isDisabled}
                readOnly={isDisabled}
                errorMessage={error}
                autoFocus={autoFocus}
                maxLength={maxLength}
            />
        </Flex>
        {children}
    </Flex>
);
